import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminContent from "@/pages/admin/AdminContent";

export const Route = createFileRoute("/admin/content")({
  component: () => (
    <ProtectedRoute>
      <AdminContent />
    </ProtectedRoute>
  ),
});
